import React, { useState, useEffect } from "react";
import { faEye, faEyeSlash, faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import PasswordChecklist from "react-password-checklist";
import Blue_Round_Btn from "../../common-components/common-btn/blue_round_btn/Blue_Round_Btn";
import Success_Modal from "../../common-components/common-modals/success_modal/Success_Modal";
import Red_Round_Btn from "../../common-components/common-btn/red_round_btn/Red_Round_Btn";
import { forgotPassword } from "../../../features/auth/authSlice";
import { useDispatch } from "react-redux";


const Set_New_Password = ({ email, contact, setEmail, setContact, ...props }) => {
  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const navigate = useNavigate();

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const dispatch = useDispatch()

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onSubmit = async (d) => {

    const data = {
      email: email,
      contact_no: contact,
      password: d?.password
    }

    const verify = await dispatch(forgotPassword(data));

    if (verify.meta?.requestStatus === "fulfilled") {
      setShowModal(true);
      setEmail('');
      setContact("");
      setTimeout(() => {
        setShowModal(false);
        navigate("/login");
      }, 2000);
    } else if (verify.meta?.requestStatus === "rejected") {

      setError("password", { type: "custom", message: verify.payload?.errors })
    }

  }


   useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className="Login Reset_Password">
      <div className="container">
        <div className="content_div">
          <div className="row">
            <div className="col-lg-6 my-auto">
              <div className="all_form_holder">
                <div className="goto_home_div" onClick={() => navigate("/")}>
                  <FontAwesomeIcon icon={faHome} className="home_icon" />
                </div>

                <div className="common_form_div">
                  <p className="title_text">Set New Password</p>
                  <p className="subtitle_text">
                    Secure your account with a new password
                  </p>

                  <div className="login_div">
                    <div className="login_form_div">
                      <Form>
                        <Form.Group className="gray_input_group input_group">
                          <Form.Label className="label_text">
                            Enter New Password
                          </Form.Label>
                          <div className="password_holder">
                            <Form.Control
                              type={showPassword ? "text" : "password"}
                              name="password"
                              placeholder="Enter password"
                              {...register("password", {
                                required: "Password is required",
                                minLength: {
                                  value: 8,
                                  message:
                                    "Password must be at least 8 characters long",
                                },
                                pattern: {
                                  value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                                  message:
                                    "Password must contain at least one uppercase letter, one lowercase letter, and one number",
                                },
                              })}
                              onChange={(e) => setPassword(e.target.value)}
                            />
                            {errors?.password && (
                              <sup className="text-danger">
                                {errors?.password?.message}
                              </sup>
                            )}
                            <div className="eye-icc">
                              <FontAwesomeIcon
                                icon={iconOne}
                                className="icon"
                                onClick={() =>
                                  togglePasswordVisibility("password")
                                }
                              />
                            </div>
                          </div>
                        </Form.Group>

                        <Form.Group className="gray_input_group input_group">
                          <Form.Label className="label_text">
                            Confirm Password
                          </Form.Label>
                          <div className="password_holder">
                            <Form.Control
                              type={showPasswordOne ? "text" : "password"}
                              name="re_password"
                              placeholder="Confirm Password"
                              {...register("re_password", {
                                required: "Re-Enter Password  is required",
                              })}
                              onChange={(e) => setPasswordAgain(e.target.value)}
                            />

                            <div className="eye-icc">
                              <FontAwesomeIcon
                                icon={iconTwo}
                                className="icon"
                                onClick={() =>
                                  togglePasswordVisibility("reenterPassword")
                                }
                              />
                            </div>
                            {errors?.re_password && (
                              <sup className="text-danger">
                                {errors?.re_password?.message}
                              </sup>
                            )}
                          </div>
                        </Form.Group>

                        {password && (
                          <div className="password_check_list">
                            <PasswordChecklist
                              rules={[
                                "minLength",
                                "specialChar",
                                "number",
                                "capital",
                                "match",
                              ]}
                              minLength={8}
                              value={password}
                              valueAgain={passwordAgain}
                              onChange={(isValid) => { }}
                              style={{
                                fontSize: "10px",
                                padding: "4px",
                                margin: "0",
                              }}
                            />
                          </div>
                        )}

                        <div className="btn_holder">
                          <Red_Round_Btn
                            btnText={"Cancle"}
                            onClick={() => navigate("/reset-password")}
                          />
                          <Blue_Round_Btn
                            btnText="Submit"
                            // onClick={() => {
                            //   setShowModal(true);
                            //   setTimeout(() => {
                            //     setShowModal(false);
                            //     navigate("/login");
                            //   }, 2000);
                            // }}
                            onClick={handleSubmit(onSubmit)}
                          />
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="login_img_holder">
                <img
                  src="/assets/images/login/rightimg.png"
                  className="right_img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Success_Modal
        show={showModal}
        successText={"Password Reset Succeffully!"}
        onHide={() => {
          setShowModal(false);
        }}
      />
    </section>
  );
};

export default Set_New_Password;
